import { NeoniApi } from '../lib/api'
import useInterruptibleMutation from './useInterruptibleMutation'

function useInterruptibleRefinementSave(api: NeoniApi, accountingPeriodId?: string) {
	return useInterruptibleMutation(
		api,
		accountingPeriodId,
		'The refinement was interrupted. Changes may already have been saved. Reopen the accounting period and check the data before trying again.'
	)
}

export default useInterruptibleRefinementSave
